import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  id: "L7",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 100 100",
  "xml:space": "preserve"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  dur: "2s",
  from: "0 50 50",
  to: "360 50 50",
  repeatCount: "indefinite"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  dur: "1s",
  from: "0 50 50",
  to: "-360 50 50",
  repeatCount: "indefinite"
}, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["fill"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  dur: "2s",
  from: "0 50 50",
  to: "360 50 50",
  repeatCount: "indefinite"
}, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]

import {computed} from 'vue';
interface Props {
	color?: string,
	diameter?: number
}

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'pLoading',
  props: {
    color: { default: '000' },
    diameter: { default: 64 }
  },
  setup(__props: any) {

const props = __props;

// Computed
const style = computed(() => {
	return `width:${props.diameter}px; height:${props.diameter}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "p-loading",
    style: _normalizeStyle(style.value)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("path", {
        fill: _ctx.color,
        d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3\n          c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
      }, _hoisted_4, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("path", {
        fill: _ctx.color,
        d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7\n          c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
      }, _hoisted_7, 8 /* PROPS */, _hoisted_5),
      _createElementVNode("path", {
        fill: _ctx.color,
        d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5\n          L82,35.7z"
      }, _hoisted_10, 8 /* PROPS */, _hoisted_8)
    ]))
  ], 4 /* STYLE */))
}
}

})